import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import translationEn from './locales/en/translation.json';
import errorsEn from './locales/en/errors.json';

import commonDe from './locales/de/common.json';
import translationDe from './locales/de/translation.json';
import errorsDe from './locales/de/errors.json';

export const SUPPORTED_LOCALES = ['de', 'en'] as const;
export const DEFAULT_LOCALE = SUPPORTED_LOCALES[0];

export type Locale = (typeof SUPPORTED_LOCALES)[number];

// index.html ships `de-AT` as the pre-JS default. Without the sync, the English
// UI still claims to be German, and Chrome keeps offering to translate it
// (samera/samera#3591).
const HTML_LANG: Record<Locale, string> = { de: 'de-AT', en: 'en' };

const syncHtmlLang = (): void => {
  // api.lib.test.ts imports this module under the node environment.
  if (typeof document === 'undefined') return;
  document.documentElement.lang =
    HTML_LANG[i18n.resolvedLanguage as Locale] ?? HTML_LANG[DEFAULT_LOCALE];
};

// Registered before init, so the detector's initial language is covered too.
// Covers the switcher, `?language=` and the detector in one place.
i18n.on('languageChanged', syncHtmlLang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage'],
    },
    resources: {
      en: {
        common: commonEn,
        translation: translationEn,
        errors: errorsEn,
      },
      de: {
        common: commonDe,
        translation: translationDe,
        errors: errorsDe,
      },
    },
    ns: ['common', 'translation', 'errors'],
    defaultNS: 'translation',
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
    },
    // debug: import.meta.env.DEV,
  });
// Not dead code: sets lang once even if init emitted no languageChanged.
syncHtmlLang();

export default i18n;
